export function moveToUrl(path){
    window.location.href = path
}

export function return_rakutesu(){
    window.location.href = "/client/tests";
}
